import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

function LaunchCommunity() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const launch = async () => {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        navigate('/');
        return;
      }

      console.log('Making request to set-community-cookie');
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/set-community-cookie`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Accept': 'application/json'
        }
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', [...response.headers.entries()]);

      const data = await response.json();
      console.log('Response data:', data);

      // Check cookies after the request
      console.log('Current cookies:', document.cookie);

      if (response.ok) {
        const redirectUrl = Array.from(searchParams.entries())
          .find(([key]) => key.toLowerCase() === 'redirecturl')?.[1];
        
        if (redirectUrl) {
          console.log('Setting communityIFrameUrl to', redirectUrl);
          localStorage.setItem('communityIFrameUrl', redirectUrl);
        } 

        navigate('/community');
        return;
      }

      console.error('Failed to set community cookie');
      navigate('/');
      return;
    };

    launch();
  }, [searchParams, navigate]);

  return null;
}

export default LaunchCommunity; 